import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { pxToRemLiteral } from '../../../../utils/pxToRemLiteral/pxToRemLiteral';
export const buildFont = (config) => {
    return {
        [DeviceBreakpointsType.DESKTOP]: {
            font_size: pxToRemLiteral(config[DeviceBreakpointsType.DESKTOP][0]),
            line_height: pxToRemLiteral(config[DeviceBreakpointsType.DESKTOP][1]),
        },
        [DeviceBreakpointsType.TABLET]: {
            font_size: pxToRemLiteral(config[DeviceBreakpointsType.TABLET][0]),
            line_height: pxToRemLiteral(config[DeviceBreakpointsType.TABLET][1]),
        },
        [DeviceBreakpointsType.MOBILE]: {
            font_size: pxToRemLiteral(config[DeviceBreakpointsType.MOBILE][0]),
            line_height: pxToRemLiteral(config[DeviceBreakpointsType.MOBILE][1]),
        },
    };
};
//# sourceMappingURL=buildFont.js.map